import React from 'react';
import { useSelector } from 'react-redux';

import { LadderTableFetcher } from './LadderTableFetcher';
import { LiveLadderDataFetcher } from './LiveLadderDataFetcher';
import { useGetCurrentCompFilters } from 'common/react/components/competition-nav/hooks/use-get-current-comp-filters';
import { liveSelector } from 'store/modules/competition-nav/selectors';
import { EmptyState } from 'common/react/components/EmptyState';
import { SkeletonLoader } from 'common/react/components/SkeletonLoader';

export const LadderTable = () => {
    const { competitionId, compSeason, round, roundLoadError } =
        useGetCurrentCompFilters();

    const live = useSelector(liveSelector);
    const isLive = live?.isActive;

    if (roundLoadError) {
        return (
            <div style={{ padding: '3.2rem 1.6rem' }}>
                <EmptyState cssClass="competition-nav__empty-state" />
            </div>
        );
    }

    if (!compSeason || !round) {
        return <SkeletonLoader className="ladder__item-skeleton" count={1} />;
    }

    if (isLive) {
        return (
            <LiveLadderDataFetcher
                competitionId={competitionId}
                compSeason={compSeason}
                round={round}
            />
        );
    }

    return (
        <LadderTableFetcher
            competitionId={competitionId}
            compSeason={compSeason}
            round={round}
        />
    );
};
